"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var animation = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var Ring = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var width = _a.width,
      height = _a.height,
      color = _a.color;
  return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: inline-block;\n    width: ", "px;\n    height: ", "px;\n\n    &:after {\n      content: ' ';\n      display: block;\n      width: ", "px;\n      height: ", "px;\n      margin: 8px;\n      border-radius: 50%;\n      border: 12px solid ", ";\n      border-color: ", " transparent ", " transparent;\n      animation: ", " 1.2s linear infinite;\n    }\n  "], ["\n    display: inline-block;\n    width: ", "px;\n    height: ", "px;\n\n    &:after {\n      content: ' ';\n      display: block;\n      width: ", "px;\n      height: ", "px;\n      margin: 8px;\n      border-radius: 50%;\n      border: 12px solid ", ";\n      border-color: ", " transparent ", " transparent;\n      animation: ", " 1.2s linear infinite;\n    }\n  "])), width, height, width, height, color, color, color, animation);
});
exports.default = Ring;
var templateObject_1, templateObject_2, templateObject_3;